// Synchronous in-flight guard for chat send paths.
//
// Why: React state (`isLoading`) only updates on the next render, so two
// rapid Enter presses in the same frame both read the stale `isLoading ===
// false` closure and double-send. The admin preview deliberately keeps its
// input ENABLED while a reply is pending (focus-retention decision), so the
// input can never rely on `disabled` to swallow the second Enter. This guard
// flips synchronously on the first call and therefore blocks the duplicate
// regardless of render timing.

export interface SendGuard {
  /** Try to start a send. Returns false (and does nothing) if one is already in flight. */
  begin(): boolean;
  /** Mark the in-flight send finished (call from `finally`). */
  end(): void;
  /** Whether a send is currently in flight. */
  readonly inFlight: boolean;
}

export function createSendGuard(): SendGuard {
  let inFlight = false;
  return {
    begin() {
      if (inFlight) return false;
      inFlight = true;
      return true;
    },
    end() {
      inFlight = false;
    },
    get inFlight() {
      return inFlight;
    },
  };
}
